import React, { useEffect, useState } from 'react'
import { useCompanyConfiguration } from '../../../hooks/useCompanyConfiguration';
import { safeParseJSON } from '../../../utils/jsonValidator';
import { callApiFlow } from '../../../services/api.service';
import { ensureArray } from '../../../utils/validateResponseApi';
import { useDataAuth } from '../../../hooks/useDataAuth';

export default function useManageProductService() {
    const [{ userSession }] = useDataAuth();
    const {
        selectedCompanyId,
        companyInfo,
        activeCompanyId
    } = useCompanyConfiguration();
    const [configuration] = useState(safeParseJSON(companyInfo?.configuration));
    const [taxesSiigo, settaxesSiigo] = useState([]);

    function transformarImpuestos(arrayOriginal) {
        return arrayOriginal.filter(e => e.type === "IVA").map(objeto => ({
            code: objeto.id,
            name: objeto.name
        }));
    }
    useEffect(() => {
        if (configuration?.ERP === "siigo") {
            const getTaxesSiigo = async () => {
                let body = {
                    "id_flow": "900114098-API-INTEGRATION_SIIGO_GET_TAXES",
                    "id_company": activeCompanyId
                };
                const response = await callApiFlow(body, userSession.token);
                console.log('getTaxesSiigo ', response);
                if (response.status === 200) {
                    settaxesSiigo(transformarImpuestos(ensureArray(response.data)))
                }
            }
            getTaxesSiigo();
        }
    }, [companyInfo, configuration?.ERP, activeCompanyId, userSession.token])

    return ({
        selectedCompanyId,
        activeCompanyId,
        companyInfo,
        configuration,
        taxesSiigo
    })
}
